import QuoteForm from "@/components/QuoteForm";
import { Card } from "@/components/ui/card";
import SEO from "@/components/SEO";

export default function QuickQuote() {
  return (
    <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
      <SEO
        title="Instant Pet Transport Quote — UK & Europe"
        description="Enter pickup and drop-off. Get your exact door-to-door pet transport price instantly — for UK and European routes."
        path="/quote"
      />
      <div className="text-center max-w-2xl mx-auto">
        <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">Instant quote</span>
        <h1 className="font-display text-4xl md:text-5xl tracking-tight mt-3">Price your pet's journey in seconds.</h1>
        <p className="text-muted-foreground mt-5">
          Enter your pickup and drop-off. We calculate the exact driving distance and show your price for all three vehicles immediately.
        </p>
      </div>

      <Card className="mt-12 p-8 md:p-12 bg-card border-border" data-testid="quick-quote-card">
        <QuoteForm />
      </Card>
    </div>
  );
}
